import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CustomerObject } from 'src/app/_interfaces/cinema/CustomerObject';
import { environment } from 'src/environments/environment';

const API_URL = environment.prismaApiUrl + '/api/dispo/team_orders';

@Injectable({
  providedIn: 'root'
})
export class TeamOrderService {
  currentObject: any;
  isNew: Boolean = false;
  clipboardObject: any; // Zwischenspeicher für das kopierte Objekt

  constructor(private http: HttpClient) { }

  getAll(): Observable<any> {
    return this.http.get(API_URL);
  }

  getFilter(): Observable<any> {
    return this.http.get(API_URL + '/filter');
  }

  getAllByResourceAndDate(object: any): Observable<any> {
    console.log('call GetAllByResourceAndDate');
    return this.http.post<CustomerObject>(API_URL + '/get-all-by-resource-and-date', { data: object });
  }

  getAllByDateRange(object: any): Observable<any> {
    return this.http.post<CustomerObject>(API_URL + '/get-all-by-date-range', { data: object });
  }

  getAllUndisposedOrders(): Observable<any> {
    return this.http.get(API_URL + '/get-all-undisposed-orders');
  }

  setReserved(id: any): Observable<any> {
    return this.http.get(API_URL + '/set-reserved/' + id);
  }

  setIsCanceled(id: any): Observable<any> {
    return this.http.get(API_URL + '/set-is-canceled/' + id);
  }

  confirm(object: any): Observable<any> {
    return this.http.get(API_URL + '/confirm/' + object.id);
  }

  setIsNoShow(id: any): Observable<any> {
    return this.http.get(API_URL + '/set-is-no-show/' + id);
  }

  getTeamEvents(object): Observable<any> {
    return this.http.get(API_URL + '/get-team-events/' + object.identity);
  }

  search(string): Observable<any> {
    return this.http.get(API_URL + '/search/' + string);
  }

  export(): Observable<any> {
    return this.http.get(API_URL + '/export', { responseType: 'blob' });
  }

  send(): Observable<any> {
    return this.http.get(API_URL + '/send');
  }

  store(object: any): Observable<any> {
    return this.http.post<CustomerObject>(API_URL, { data: object });
  }

  delete(object: any): Observable<any> {
    console.log('delete:' + object.id);
    return this.http.delete(API_URL + '/' + object.id);
  }

  show(id: any): Observable<any> {
    this.currentObject = this.http.get(API_URL + '/' + id);
    return this.currentObject;
  }

  update(object: any): Observable<any> {
    return this.http.put<CustomerObject>(API_URL + '/' + object.id, { data: object });
  }

  genTeamSchedulePdf(date: any): Observable<any> {
    return this.http.get(API_URL + '/gen-team-scheduler-pdf-by-date/' + date, { responseType: 'blob' });
  }

  getCurrentObject() {
    return this.currentObject;
  }

  setIsNew(value: any) {
    this.isNew = value;
  }

  getIsNew() {
    return this.isNew;
  }

  // Neue Methode zum Kopieren eines Teamauftrags
  copyTeamOrder(object: any) {
    
    this.clipboardObject = object;
    //this.clipboardObject = { ...object }; // Objekt in den Zwischenspeicher kopieren
  }

  // Neue Methode zum Abrufen des kopierten Objekts
  getClipboardObject() {
    //return "1234567890";
   
    return this.clipboardObject;
  }

  // Neue Methode zum Einfügen des kopierten Objekts mit neuem Datum und neuer Ressource
  pasteTeamOrder(newStart: any, newEnd: any, newResource: any, showReference: any): Observable<any> {
    console.log('newStart:' + newStart);
    console.log('newEnd:' + newEnd);
    console.log('newResource:' + newResource);
    if (this.clipboardObject) {
      const updatedObject = {
        ...this.clipboardObject,
        order_id: this.getClipboardObject().order?.id,
        start: newStart,
        end: newEnd,
        resource: newResource,
        reference: showReference,
        //comment: this.getClipboardObject().source?.data?.order?.comment,
        //id: this.getClipboardObject().source?.data?.id
      };
      return this.http.post<CustomerObject>(API_URL + '/paste', { data: updatedObject });
    } else {
      throw new Error('Kein Objekt im Zwischenspeicher vorhanden');
    }
  }
}
